import emptyImage from '@fukuri-admins/assets/images/circle-company.svg';
import { ButtonLink, PlusIcon, Stack } from '@fukuri-admins/ui/common';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

export const BranchListEmptyPresentation: React.FC = () => (
  <div className={styles.container}>
    <Stack gap={24} height='100%' alignItems='center' justifyContent='center'>
      <img src={emptyImage} alt='empty list image' />
      <Stack gap={16} alignItems='center' justifyContent='center'>
        <p>事業所はまだありません</p>
        <ButtonLink to={ROUTES.BRANCHES.NEW} icon={<PlusIcon size='xs' />} iconPosition='left'>
          新規追加
        </ButtonLink>
      </Stack>
    </Stack>
  </div>
);
